export default {
  title: 'Importovať zloženie materiálu',
  helpText: 'Vložte text zloženia materiálu do poľa nižšie – napríklad skopírovaný z technického listu alebo webovej stránky. Nástroj automaticky deteguje rozsahy obsiahnutých legujúcich prvkov a zobrazí ich priamo v tabuľke náhľadu',
  failure: {
    summary: 'Boli zistené neúplné alebo nejednoznačné hodnoty',
    details: 'Niektoré legujúce prvky boli rozpoznané, ale chýbajú zodpovedajúce hodnoty alebo ich nie je možné jednoznačne interpretovať. Prosím, prezrite si zoznam nižšie a ručne doplňte chýbajúce informácie.',
    emptyValue: 'Pre legujúci prvok nebola nájdená žiadna hodnota',
    addToComposition: 'Pridať prvok',
    removeFromComposition: 'Odstrániť prvok',
  },
};
